/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import EventsControllerDtoBannerListImageData from './EventsControllerDtoBannerListImageData';

/**
 * The EventsControllerDtoBannerListBannerData model module.
 * @module model/EventsControllerDtoBannerListBannerData
 * @version 1.0
 */
class EventsControllerDtoBannerListBannerData {
    /**
     * Constructs a new <code>EventsControllerDtoBannerListBannerData</code>.
     * @alias module:model/EventsControllerDtoBannerListBannerData
     */
    constructor() { 
        
        EventsControllerDtoBannerListBannerData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoBannerListBannerData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoBannerListBannerData} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoBannerListBannerData} The populated <code>EventsControllerDtoBannerListBannerData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoBannerListBannerData();

            if (data.hasOwnProperty('bannerNo')) {
                obj['bannerNo'] = ApiClient.convertToType(data['bannerNo'], 'Number');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('deeplink')) {
                obj['deeplink'] = ApiClient.convertToType(data['deeplink'], 'String');
            }
            if (data.hasOwnProperty('region')) {
                obj['region'] = ApiClient.convertToType(data['region'], 'String');
            }
            if (data.hasOwnProperty('beginDate')) {
                obj['beginDate'] = ApiClient.convertToType(data['beginDate'], 'Date');
            }
            if (data.hasOwnProperty('endDate')) {
                obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
            }
            if (data.hasOwnProperty('createAt')) {
                obj['createAt'] = ApiClient.convertToType(data['createAt'], 'Date');
            }
            if (data.hasOwnProperty('sortingIndex')) {
                obj['sortingIndex'] = ApiClient.convertToType(data['sortingIndex'], 'Number');
            }
            if (data.hasOwnProperty('imageFileName')) {
                obj['imageFileName'] = ApiClient.convertToType(data['imageFileName'], 'String');
            }
            if (data.hasOwnProperty('cache')) {
                obj['cache'] = ApiClient.convertToType(data['cache'], 'Number');
            }
            if (data.hasOwnProperty('imageUrls')) {
                obj['imageUrls'] = ApiClient.convertToType(data['imageUrls'], [EventsControllerDtoBannerListImageData]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoBannerListBannerData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoBannerListBannerData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
            throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
        }
        // ensure the json data is a string
        if (data['deeplink'] && !(typeof data['deeplink'] === 'string' || data['deeplink'] instanceof String)) {
            throw new Error("Expected the field `deeplink` to be a primitive type in the JSON string but got " + data['deeplink']);
        }
        // ensure the json data is a string
        if (data['region'] && !(typeof data['region'] === 'string' || data['region'] instanceof String)) {
            throw new Error("Expected the field `region` to be a primitive type in the JSON string but got " + data['region']);
        }
        // ensure the json data is a string
        if (data['imageFileName'] && !(typeof data['imageFileName'] === 'string' || data['imageFileName'] instanceof String)) {
            throw new Error("Expected the field `imageFileName` to be a primitive type in the JSON string but got " + data['imageFileName']);
        }
        if (data['imageUrls']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['imageUrls'])) {
                throw new Error("Expected the field `imageUrls` to be an array in the JSON data but got " + data['imageUrls']);
            }
            // validate the optional field `imageUrls` (array)
            for (const item of data['imageUrls']) {
                EventsControllerDtoBannerListImageData.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} bannerNo
 */
EventsControllerDtoBannerListBannerData.prototype['bannerNo'] = undefined;

/**
 * @member {String} title
 */
EventsControllerDtoBannerListBannerData.prototype['title'] = undefined;

/**
 * @member {String} deeplink
 */
EventsControllerDtoBannerListBannerData.prototype['deeplink'] = undefined;

/**
 * @member {String} region
 */
EventsControllerDtoBannerListBannerData.prototype['region'] = undefined;

/**
 * @member {Date} beginDate
 */
EventsControllerDtoBannerListBannerData.prototype['beginDate'] = undefined;

/**
 * @member {Date} endDate
 */
EventsControllerDtoBannerListBannerData.prototype['endDate'] = undefined;

/**
 * @member {Date} createAt
 */
EventsControllerDtoBannerListBannerData.prototype['createAt'] = undefined;

/**
 * @member {Number} sortingIndex
 */
EventsControllerDtoBannerListBannerData.prototype['sortingIndex'] = undefined;

/**
 * @member {String} imageFileName
 */
EventsControllerDtoBannerListBannerData.prototype['imageFileName'] = undefined;

/**
 * @member {Number} cache
 */
EventsControllerDtoBannerListBannerData.prototype['cache'] = undefined;

/**
 * @member {Array.<module:model/EventsControllerDtoBannerListImageData>} imageUrls
 */
EventsControllerDtoBannerListBannerData.prototype['imageUrls'] = undefined;






export default EventsControllerDtoBannerListBannerData;

